"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lit_html_1 = require("lit-html");
const reduxular_1 = require("reduxular");
const utilities_1 = require("../../../services/utilities");
const define_custom_element_1 = require("../../../utilities/define-custom-element");
require("../jo-company-crew-cal/jo-company-crew-cal-management/jo-company-crew-cal-management");
const InitialState = {
    authenticatedUser: 'NOT_SET',
    companyId: 'NOT_SET',
};
class JOCustomerCrewCalManagement extends HTMLElement {
    constructor() {
        super(...arguments);
        this.store = (0, reduxular_1.createObjectStore)(InitialState, (state) => (0, lit_html_1.render)(this.render(state), this), this, utilities_1.setPropsReducer);
    }
    set props(props) {
        if ((0, utilities_1.deepLeftCheck)(props, this.store.getState()) === true) {
            return;
        }
        this.store.dispatch({
            type: 'SET_PROPS',
            props,
        });
    }
    render(state) {
        return (0, lit_html_1.html) `
            <link rel="stylesheet" href="/styles/jo-styles.css" />
            <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />

            <jo-company-crew-cal-management
                .companyId=${state.companyId}
            ></jo-company-crew-cal-management>
        `;
    }
}
(0, define_custom_element_1.defineCustomElement)('jo-customer-crew-cal-management', JOCustomerCrewCalManagement);
